module.exports = __webpack_public_path__ + "static/pbzcard-logo-e82045339caad52fc12e7c2354d314a0.svg";